import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { NotificationType } from '../../redux/types';
import FaveNotification from '../../../FaveButton/FaveNotification';
import CollectNotification from '../../../CollectionPanel/CollectNotification';
import CommentDeleteNotification from '../../../CommentDeleteNotification';
import GroupAddedNotification from '../../../AddToGroupsPanel/_partials/GroupAddedNotification';
import LiveNotification from '../../../LiveNotifications/LiveNotification';
import BadgeNotification from '../../../coreBadge/BadgeNotification';
import GenericNotification from '../../GenericNotification';
import GenericUndoNotification from '../../GenericUndoNotification';
import DeviationUnpublishedNotification from '../../../DeviationUnpublishedNotification';
const NotificationContent = ({ notification, onlyUseRenderFunction, removeNotification, children })=>{
    if (!notification) {
        return null;
    }
    // this can be helpful when you have two Notifications components but
    // want each to display different types of notifications (without both duplicating all)
    if (onlyUseRenderFunction) {
        return children ? /*#__PURE__*/ React.createElement(React.Fragment, null, children(notification, removeNotification)) : null;
    }
    switch(notification.type){
        case NotificationType.Collect:
        case NotificationType.CollectPrivate:
        case NotificationType.CollectUndo:
            return /*#__PURE__*/ React.createElement(CollectNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.Fave:
        case NotificationType.FaveUndo:
            return /*#__PURE__*/ React.createElement(FaveNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.DeleteComment:
            return /*#__PURE__*/ React.createElement(CommentDeleteNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.AddToGroup:
            return /*#__PURE__*/ React.createElement(GroupAddedNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.Unpublish:
            return /*#__PURE__*/ React.createElement(DeviationUnpublishedNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.Live:
            return /*#__PURE__*/ React.createElement(LiveNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName,
                notificationHtml: notification.params.message,
                biData: notification.params.bi_data,
                linkTo: notification.params.url
            }, notification.params));
        case NotificationType.Generic:
            return /*#__PURE__*/ React.createElement(GenericNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.GenericUndo:
            return /*#__PURE__*/ React.createElement(GenericUndoNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.Badge:
            return /*#__PURE__*/ React.createElement(BadgeNotification, _object_spread({
                id: notification.id,
                queueName: notification.queueName,
                removeNotification: removeNotification
            }, notification.params));
        default:
            if (!children) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(React.Fragment, null, children(notification, removeNotification));
    }
};
NotificationContent.displayName = 'NotificationContent';
export default NotificationContent;

//# sourceMappingURL=NotificationContent.js.map